import React from 'react';
import { createSvgIcon } from '../../icon';
/* eslint-disable max-len */
export default createSvgIcon('download', '0 0 96 96', React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M86.7 34.2H64.6V1H31.4v33.2H9.3L48 72.9zM9.3 83.9h77.4V95H9.3z" })));
